// src/pages/MainsExamination.jsx
import React from "react";
import mainsData from "../../data/syllabus-data/mainsData";

function MainsExamination() {
  return (
    <div
      id="mains"
      className="max-w-7xl mx-auto p-6 bg-white rounded-lg shadow-md"
    >
      <h2 className="text-2xl font-bold mb-6">Mains Examination Structure</h2>
      <div className="space-y-6">
        {mainsData.map((section, idx) => (
          <div key={idx} className="bg-gray-50 p-5 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold text-gray-800">
              {section.section}
            </h3>

            {section.description && (
              <p className="mt-2 text-gray-700">{section.description}</p>
            )}

            {section.points && (
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                {section.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}

            {section.papers && (
              <div className="mt-4 space-y-4">
                {section.papers.map((paper, i) => (
                  <div key={i} className="bg-white p-4 rounded-md border">
                    <h4 className="font-semibold text-lg">{paper.title}</h4>

                    {/* Paper description */}
                    {paper.desc && (
                      <div className="list-disc ml-6 mt-2 text-gray-700">
                        {paper.desc.map((d, di) => (
                          <p key={di}>{d}</p>
                        ))}
                      </div>
                    )}

                    {/* Subtitle for Essay paper */}
                    {paper.subtitle && (
                      <div className="mt-2">
                        <h5 className="font-semibold italic text-gray-800 mb-1">
                          {paper.subtitle}
                        </h5>
                      </div>
                    )}

                    {/* Paper details */}
                    {paper.details && (
                      <ul className="list-disc ml-6 mt-2 text-gray-700">
                        {paper.details.map((detail, di) => (
                          <li key={di}>{detail}</li>
                        ))}
                      </ul>
                    )}

                    {paper.content && (
                      <div className="list-disc ml-6 mt-2 text-gray-700">
                        {paper.content.map((conten, co) => (
                          <p key={co}>{conten}</p>
                        ))}
                      </div>
                    )}

                    {/* Table for languages (Paper A only) */}
                    {paper.tableTitle && (
                      <div className="mt-4">
                        <h5 className="font-semibold text-gray-800 mb-2">
                          {paper.tableTitle}
                        </h5>
                        <div className="overflow-x-auto">
                          <table className="min-w-full border border-gray-300 text-sm text-gray-700">
                            <tbody>
                              {paper.tableData.map((row, ri) => (
                                <tr key={ri} className="border-t">
                                  {row.map((cell, ci) => (
                                    <td
                                      key={ci}
                                      className="border px-3 py-2 text-center"
                                    >
                                      {cell}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MainsExamination;
